var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCardDraging)?_c('div',{staticClass:"animation-text"},[_c('img',{staticClass:"img__24 mr__8",class:{ 'img__28': _vm.isDesktop},attrs:{"src":_vm.animationImg}}),_c('markdown',{staticClass:"text-lSemibold",class:{
                'title-baseSemibold': _vm.isDesktop,
                'color__raspberry': _vm.showDelete,
                'color__lime': _vm.showKeep,
                'color__aquamarine': _vm.showLater,
                'color__sunset': _vm.showDeleteKeepReceiving
              },attrs:{"text":_vm.animationText}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }